import { FC, PropsWithChildren } from 'react';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import {
  BlocksCheckboxChangeEvent,
  BlocksSelectEvent
} from '@blocks-web-components/events';
import { ListMenuType } from './ListMenuItemType';
import styles from './styles.module.scss';
import cx from 'classnames';

interface ListMenuItemProps {
  item: { id: string; name: string; checked?: boolean; count?: string };
  type?: string;
  handleItemClick: (e: BlocksCheckboxChangeEvent | BlocksSelectEvent) => void;
  className?: string;
}

export const ListMenuItem: FC<PropsWithChildren<ListMenuItemProps>> = ({
  handleItemClick,
  item,
  type,
  className
}) => {
  if (type === ListMenuType.CHECKBOX) {
    const shouldDisableFacet = !Number(item.count);
    return (
      <CatListItem
        key={item.id}
        data-testid="list-menu-item-checkbox"
        value={item.id}
        isStatic={shouldDisableFacet}
        className={className}
      >
        <CatCheckboxField
          onBlCheckboxChange={(e) => handleItemClick(e)}
          checked={item.checked}
          disabled={shouldDisableFacet}
          value={item.id}
          role="menuitemcheckbox"
          className={cx({
            [styles['list-menu-item-checkbox']]: shouldDisableFacet
          })}
        >
          {item.name}
        </CatCheckboxField>
      </CatListItem>
    );
  }

  return (
    <CatListItem
      key={item.id}
      data-testid="list-menu-item"
      onBlSelect={(e) => handleItemClick(e)}
      value={item.id}
      className={className}
    >
      {item.name}
    </CatListItem>
  );
};
